import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeActionTypeWidgetInnerCheckoutButtonParts = uiPartCreateNamespacedParts('DoppeActionTypeWidgetInnerCheckoutButtonParts', {
    Root: 'Root',
})

export function doppeActionTypeWidgetInnerCheckoutButtonPartsCreateName(actionId: string, name?: string) {
    return `${actionId}-${name ?? 'default'}`;

}